module.exports = __webpack_public_path__ + "static/img/preview-01.ef10ac08.webp";